import { type InventoryProduct } from 'types/model'

export function validateStock (product: InventoryProduct, value: number) {
  return product.stock >= value
}
